var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React, { Component, Fragment } from 'react';
import { default as styled } from 'styled-components';
import { withSuomifiDefaultProps } from '../theme/utils';
import { baseStyles, menuListStyles } from './Dropdown.baseStyles';
import { MenuList as CompMenuList, } from '../../components/Menu/Menu';
import { Dropdown as CompDropdown, } from '../../components/Dropdown/Dropdown';
import { DropdownItem } from './DropdownItem';
var StyledDropdown = styled(function (_a) {
    var tokens = _a.tokens, passProps = __rest(_a, ["tokens"]);
    return (React.createElement(CompDropdown, __assign({}, passProps, { dropdownItemProps: { className: 'fi-dropdown_item' } })));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return baseStyles(props); });
var StyledMenuList = styled(function (_a) {
    var tokens = _a.tokens, passProps = __rest(_a, ["tokens"]);
    return (React.createElement(CompMenuList, __assign({}, passProps)));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return menuListStyles(props.theme); });
var Dropdown = (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dropdown.prototype.render = function () {
        var props = withSuomifiDefaultProps(this.props);
        return (React.createElement(Fragment, null,
            React.createElement(StyledDropdown, __assign({}, props, { menuListComponent: StyledMenuList }))));
    };
    Dropdown.item = function (props) { return React.createElement(DropdownItem, __assign({}, props)); };
    return Dropdown;
}(Component));
export { Dropdown };
var templateObject_1, templateObject_2;
//# sourceMappingURL=Dropdown.js.map